export default function BookingCTA() {
  return (
    <section id="prijs-aanvragen" className="py-20 bg-slate-900">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Klaar om te reserveren?
        </h2>
        <p className="text-xl text-slate-300 mb-10 leading-relaxed">
          Neem direct contact op voor een vaste prijs of om uw rit te boeken. Wij zijn 24/7 bereikbaar.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="tel:+31658824429" 
            className="w-full sm:w-auto px-8 py-4 bg-amber-500 text-white text-lg font-bold rounded-lg hover:bg-amber-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Bel Direct: 06 5882 4429
          </a>
          
          <a 
            href="https://wa.me/31658824429?text=Hallo,%20ik%20wil%20graag%20een%20airport%20taxi%20boeken." 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-4 bg-green-500 text-white text-lg font-bold rounded-lg hover:bg-green-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            WhatsApp Reserveren
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 text-slate-400">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-green-400 text-xl"></i>
            <span className="text-sm">Veilig & Betrouwbaar</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-green-400 text-xl"></i>
            <span className="text-sm">24/7 Bereikbaar</span>
          </div>
        </div>
      </div>
    </section>
  );
}
